import { Box, Link, Paper } from '@/shared/ui';

import useLinkBar from '@/app/components/LinkBar/useLinkBar';
import renderSanitizedHtml from '@/shared/lib/renderSanitizedHtml';

const LinkBar = () => {
  const { linkUrl, linkMessage } = useLinkBar();

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%',
        gap: 3
      }}
    >
      <Paper
        sx={{
          width: '100%',
          height: '48px',
          color: 'gx.textSecondary',
          display: 'flex',
          alignItems: 'center',
          px: 2
        }}
      >
        <Link
          color='gx.textSecondary'
          href={linkUrl}
          rel='noopener noreferrer'
          sx={{ textDecoration: 'none' }}
          target='_blank'
        >
          {renderSanitizedHtml(linkMessage)}
        </Link>
      </Paper>
    </Box>
  );
};

export default LinkBar;
